import { Box, Button } from "@mui/material";
import { Save, Cancel, Add, CheckCircle, Refresh, RestartAlt } from "@mui/icons-material";

const MobileActionButtons = ({
  onSave,
  onCancel,
  onAddExercise,
  onFinishWorkout,
  onResetWeek,
  onRerunManipulation,
  isWeekFinished,
  isWorkoutCompleted,
  isPlanActive,
  canRerunManipulation
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "100px",
        left: 0,
        right: 0,
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E2E8F0",
        padding: "12px 16px",
        zIndex: 999,
        direction: "rtl"
      }}
    >
      {/* Primary Actions Row */}
      <Box sx={{ display: "flex", gap: 1, marginBottom: "8px" }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<Save />}
          onClick={onSave}
          disabled={isWeekFinished}
          sx={{
            backgroundColor: "#3B82F6",
            fontSize: "13px",
            fontWeight: 600,
            padding: "10px",
            borderRadius: "8px",
            "&:hover": { backgroundColor: "#2563EB" },
            "&:disabled": { backgroundColor: "#E2E8F0", color: "#94A3B8" }
          }}
        >
          שמור ושלח
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<Cancel />}
          onClick={onCancel}
          sx={{
            color: "#64748B",
            borderColor: "#E2E8F0",
            fontSize: "13px",
            fontWeight: 600,
            padding: "10px",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#F8FAFC",
              borderColor: "#CBD5E1"
            }
          }}
        >
          בטל
        </Button>
      </Box>

      {/* Secondary Actions Row */}
      <Box sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap"
      }}>
        <Button
          size="small"
          startIcon={<Add />}
          onClick={onAddExercise}
          sx={{
            flex: 1,
            color: "#1E293B",
            backgroundColor: "#F1F5F9",
            fontSize: "11px",
            fontWeight: 600,
            padding: "8px 12px",
            borderRadius: "6px",
            "&:hover": { backgroundColor: "#E2E8F0" }
          }}
        >
          הוסף תרגיל
        </Button>

        {!isWorkoutCompleted && (
          <Button
            size="small"
            startIcon={<CheckCircle />}
            onClick={onFinishWorkout}
            disabled={!isPlanActive}
            sx={{
              flex: 1,
              color: "#22C55E",
              backgroundColor: "#F0FDF4",
              fontSize: "11px",
              fontWeight: 600,
              padding: "8px 12px",
              borderRadius: "6px",
              "&:hover": { backgroundColor: "#DCFCE7" },
              "&:disabled": { backgroundColor: "#F8FAFC", color: "#CBD5E1" }
            }}
          >
            סיים אימון
          </Button>
        )}

        <Button
          size="small"
          startIcon={<RestartAlt />}
          onClick={onResetWeek}
          disabled={!isPlanActive}
          sx={{
            flex: 1,
            color: "#64748B",
            backgroundColor: "#F8FAFC",
            fontSize: "11px",
            fontWeight: 600,
            padding: "8px 12px",
            borderRadius: "6px",
            border: "1px solid #E2E8F0",
            "&:hover": { backgroundColor: "#F1F5F9" },
            "&:disabled": { backgroundColor: "#FAFAFA", color: "#CBD5E1" }
          }}
        >
          אפס שבוע
        </Button>

        <Button
          size="small"
          startIcon={<Refresh />}
          onClick={onRerunManipulation}
          disabled={!isPlanActive || !canRerunManipulation}
          sx={{
            flex: 1,
            color: "#64748B",
            backgroundColor: "#F8FAFC",
            fontSize: "10px",
            fontWeight: 600,
            padding: "8px 10px",
            borderRadius: "6px",
            border: "1px solid #E2E8F0",
            "&:hover": { backgroundColor: "#F1F5F9" },
            "&:disabled": { backgroundColor: "#FAFAFA", color: "#CBD5E1" }
          }}
        >
          מניפולציה
        </Button>
      </Box>
    </Box>
  );
};

export default MobileActionButtons;
